import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { MailIcon, ShieldIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export const Support = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="font-[Inter,ui-sans-serif,system-ui] text-[#0B1220] overflow-x-hidden relative bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-961">
      {/* Cinematic frame markers - subtle guides at the edges of the viewport */}
      <div className="fixed inset-x-0 top-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-962"></div>
      <div className="fixed inset-x-0 bottom-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-963"></div>
      <div className="fixed inset-y-0 left-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-964"></div>
      <div className="fixed inset-y-0 right-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-965"></div>
      {/* Dynamic background elements */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-966">
        <div className="absolute top-0 right-0 w-[80vw] h-[80vh] rounded-full bg-gradient-to-b from-[#2E6BFF]/5 to-transparent opacity-40 blur-[120px]" data-id="element-967"></div>
        <div className="absolute bottom-0 left-0 w-[70vw] h-[70vh] rounded-full bg-gradient-to-t from-[#36D1DC]/5 to-transparent opacity-40 blur-[100px]" data-id="element-968"></div>
        <motion.div className="absolute top-1/4 left-1/4 w-[50vw] h-[50vh] rounded-full bg-gradient-to-r from-[#0BB489]/5 to-transparent opacity-30 blur-[80px]" animate={{
        x: [0, 20, 0],
        y: [0, -20, 0]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-969"></motion.div>
      </div>
      <Navbar data-id="element-970" />
      <main className="relative z-10 pt-24 pb-16" data-id="element-971">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-972">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 border border-white/50" data-id="element-973">
            <h1 className="text-3xl font-bold mb-6 text-[#0B1220]" data-id="element-974">
              Pigeon Support
            </h1>
            <div className="space-y-8 text-[#0B1220]" data-id="element-975">
              <p className="text-lg" data-id="element-976">
                We're here to assist you with any questions, concerns, or issues
                you may have while using Pigeon, your trusted document transfer
                platform. Our dedicated support team is ready to help you make
                the most of your Pigeon experience.
              </p>
              <section data-id="element-977">
                <h2 className="text-xl font-semibold mb-4 text-[#2E6BFF]" data-id="element-978">
                  Contact Us
                </h2>
                <div className="bg-[#F0F5FF] rounded-lg p-6 border border-[#2E6BFF]/20 flex items-start" data-id="element-979">
                  <MailIcon className="h-6 w-6 text-[#2E6BFF] mr-4 mt-0.5 flex-shrink-0" data-id="element-980" />
                  <div data-id="element-981">
                    <p className="text-lg mb-2" data-id="element-982">
                      Send us an email at{' '}
                      <a href="mailto:support@pigeondocuments.com" className="text-[#2E6BFF] hover:underline" data-id="element-983">
                        support@pigeondocuments.com
                      </a>
                      , and we'll get back to you as soon as possible.
                    </p>
                    <div className="flex items-center mt-4 text-sm text-[#5A6376]" data-id="element-984">
                      <ClockIcon className="h-4 w-4 mr-2" data-id="element-985" />
                      <span data-id="element-986">Typical response time: Within 2 business days</span>
                    </div>
                  </div>
                </div>
              </section>
              <section data-id="element-987">
                <h2 className="text-xl font-semibold mb-4 text-[#2E6BFF]" data-id="element-988">
                  Vulnerability Report/Disclosure
                </h2>
                <div className="space-y-6" data-id="element-989">
                  <div data-id="element-990">
                    <h3 className="font-medium text-lg mb-2" data-id="element-991">
                      How to Submit a Vulnerability
                    </h3>
                    <p data-id="element-992">
                      To submit a vulnerability report to Pigeon Documents's
                      Product Security Team, please utilize the following email:{' '}
                      <a href="mailto:support@pigeondocuments.com" className="text-[#2E6BFF] hover:underline" data-id="element-993">
                        support@pigeondocuments.com
                      </a>
                      .
                    </p>
                  </div>
                  <div data-id="element-994">
                    <h3 className="font-medium text-lg mb-2" data-id="element-995">
                      Preference, Prioritization, and Acceptance Criteria
                    </h3>
                    <p className="mb-4" data-id="element-996">
                      We will use the criteria from the next sections to
                      prioritize and triage submissions. What we would like to
                      see from you:
                    </p>
                    <ul className="space-y-2 pl-5 list-disc" data-id="element-997">
                      <li data-id="element-998">
                        Well-written reports in English will have a higher
                        probability of resolution.
                      </li>
                      <li data-id="element-999">
                        Reports that include proof-of-concept code equip us to
                        better triage.
                      </li>
                      <li data-id="element-1000">
                        Reports that include only crash dumps or other automated
                        tool output may receive lower priority.
                      </li>
                      <li data-id="element-1001">
                        Reports that include products not on the initial scope
                        list may receive lower priority.
                      </li>
                      <li data-id="element-1002">
                        Please include how you found the bug, the impact, and
                        any potential remediation.
                      </li>
                      <li data-id="element-1003">
                        Please include any plans or intentions for public
                        disclosure.
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              <section data-id="element-1004">
                <h2 className="text-xl font-semibold mb-4 text-[#2E6BFF]" data-id="element-1005">
                  What you can expect from Pigeon Documents
                </h2>
                <div className="grid gap-4 sm:grid-cols-2" data-id="element-1006">
                  <div className="bg-white rounded-lg p-5 border border-[#E7EAF0] shadow-sm" data-id="element-1007">
                    <div className="flex items-center mb-3" data-id="element-1008">
                      <div className="p-2 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mr-3" data-id="element-1009">
                        <ClockIcon className="h-5 w-5" data-id="element-1010" />
                      </div>
                      <h3 className="font-medium" data-id="element-1011">Timely Response</h3>
                    </div>
                    <p className="text-[#5A6376]" data-id="element-1012">
                      A timely response to your email (within 2 business days).
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-[#E7EAF0] shadow-sm" data-id="element-1013">
                    <div className="flex items-center mb-3" data-id="element-1014">
                      <div className="p-2 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mr-3" data-id="element-1015">
                        <ShieldIcon className="h-5 w-5" data-id="element-1016" />
                      </div>
                      <h3 className="font-medium" data-id="element-1017">Transparent Process</h3>
                    </div>
                    <p className="text-[#5A6376]" data-id="element-1018">
                      After triage, we will send an expected timeline and commit
                      to being transparent about the remediation process.
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-[#E7EAF0] shadow-sm" data-id="element-1019">
                    <div className="flex items-center mb-3" data-id="element-1020">
                      <div className="p-2 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mr-3" data-id="element-1021">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-square" data-id="element-1022">
                          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" data-id="element-1023" />
                        </svg>
                      </div>
                      <h3 className="font-medium" data-id="element-1024">Open Dialog</h3>
                    </div>
                    <p className="text-[#5A6376]" data-id="element-1025">
                      An open dialog to discuss issues and find the best
                      solutions.
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-[#E7EAF0] shadow-sm" data-id="element-1026">
                    <div className="flex items-center mb-3" data-id="element-1027">
                      <div className="p-2 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mr-3" data-id="element-1028">
                        <CheckCircleIcon className="h-5 w-5" data-id="element-1029" />
                      </div>
                      <h3 className="font-medium" data-id="element-1030">Recognition</h3>
                    </div>
                    <p className="text-[#5A6376]" data-id="element-1031">
                      Credit after the vulnerability has been validated and
                      fixed.
                    </p>
                  </div>
                </div>
                <p className="mt-6" data-id="element-1032">
                  If we are unable to resolve communication issues or other
                  problems, Pigeon Documents may bring in a neutral third party
                  to assist in determining how best to handle the vulnerability.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-1033" />
    </div>;
};